import React from "react";
import { Box, ButtonBase, IconButton, Tooltip, Typography } from "@mui/material";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import PriceChangeRoundedIcon from "@mui/icons-material/PriceChangeRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import { useLocation, useNavigate } from "react-router-dom";

const tabs = [
  { value: "/dashboard/owner", label: "Agenda", icon: <CalendarMonthRoundedIcon /> },
  { value: "/dashboard/owner/crm", label: "CRM", icon: <GroupsRoundedIcon /> },
  { value: "/dashboard/owner/finanzas", label: "Dinero", icon: <AccountBalanceWalletRoundedIcon /> },
  { value: "/dashboard/owner/precios", label: "Precios", icon: <PriceChangeRoundedIcon /> },
  { value: "/dashboard/owner/configuracion", label: "Config", icon: <SettingsRoundedIcon /> },
];

function activePath(pathname) {
  if (pathname.startsWith("/dashboard/owner/crm") || pathname.startsWith("/dashboard/owner/proyectos/") || pathname.startsWith("/dashboard/owner/clientes")) return "/dashboard/owner/crm";
  if (pathname.startsWith("/dashboard/owner/finanzas") || pathname.startsWith("/dashboard/owner/movimientos")) return "/dashboard/owner/finanzas";
  if (pathname.startsWith("/dashboard/owner/precios")) return "/dashboard/owner/precios";
  if (pathname.startsWith("/dashboard/owner/configuracion")) return "/dashboard/owner/configuracion";
  return "/dashboard/owner";
}

export default function OwnerWorkspaceNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const current = activePath(location.pathname);

  return <>
    <Box component="nav" aria-label="Navegación Owner" sx={{ display: { xs: "none", sm: "flex" }, width: 58, flex: "0 0 auto", borderRight: "1px solid", borderColor: "divider", bgcolor: "background.paper", px: .45, py: .65, flexDirection: "column", alignItems: "center", gap: .5 }}>
      {tabs.map((tab) => {
        const active = current === tab.value;
        return <Tooltip key={tab.value} title={tab.label} placement="right" arrow enterDelay={250}>
          <IconButton aria-label={`Ir a ${tab.label}`} aria-current={active ? "page" : undefined} onClick={() => navigate(tab.value)} sx={{ width: 46, height: 46, borderRadius: 2.4, color: active ? "primary.main" : "text.secondary", bgcolor: active ? "rgba(243,90,58,.10)" : "transparent", border: "1px solid", borderColor: active ? "rgba(243,90,58,.22)" : "transparent", "& svg": { fontSize: 23 } }}>{tab.icon}</IconButton>
        </Tooltip>;
      })}
    </Box>

    <Box component="nav" aria-label="Navegación móvil Owner" sx={{ display: { xs: "grid", sm: "none" }, position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 1300, gridTemplateColumns: "repeat(5,minmax(0,1fr))", px: "max(5px, env(safe-area-inset-left))", pt: .4, pb: "max(5px, env(safe-area-inset-bottom))", minHeight: "calc(62px + env(safe-area-inset-bottom))", borderTop: "1px solid", borderColor: "divider", bgcolor: "rgba(var(--wp-panel-surface-rgb,255,255,255),.97)", boxShadow: "0 -8px 26px rgba(var(--wp-panel-ink-rgb,25,36,47),.08)", backdropFilter: "blur(14px)" }}>
      {tabs.map((tab) => {
        const active = current === tab.value;
        return <ButtonBase key={tab.value} aria-label={`Ir a ${tab.label}`} aria-current={active ? "page" : undefined} onClick={() => navigate(tab.value)} sx={{ minWidth: 0, minHeight: 54, borderRadius: 2, mx: .15, color: active ? "primary.main" : "text.secondary", bgcolor: active ? "rgba(243,90,58,.09)" : "transparent", display: "flex", flexDirection: "column", gap: .1, "& svg": { fontSize: 22 } }}>{tab.icon}<Typography component="span" sx={{ fontSize: 9.5, lineHeight: 1.1, fontWeight: active ? 1000 : 800 }}>{tab.label}</Typography></ButtonBase>;
      })}
    </Box>
  </>;
}
